import {
  descriptionUI,
  titleUI,
  yesNoSchema,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import PrimaryCaregiverIntro from '../../../components/FormDescriptions/PrimaryCaregiverIntro';
import content from '../../../locales/en/content.json';

const TITLE_TEXT = content['primary-info-title--apply'];
const INPUT_LABEL = content['primary-apply-label'];

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    ...descriptionUI(PrimaryCaregiverIntro),
    'view:hasPrimaryCaregiver': yesNoUI(INPUT_LABEL),
  },
  schema: {
    type: 'object',
    required: ['view:hasPrimaryCaregiver'],
    properties: {
      'view:hasPrimaryCaregiver': yesNoSchema,
    },
  },
};
